import ReduxProvider from "@liberty-fund/data-context/provider";
import { PersistGate, persistor } from "@liberty-fund/data-context/store";
import { HostServiceProvider } from "@liberty-fund/utils/hostServices";
import { BrowserRouter } from "react-router-dom";

import { AnalyticsTracker } from "@/analytics";
import SwrProvider from "@/api/SwrProvider";
import AuthProvider, { RequireAuth } from "@/auth/AuthProvider";
import AppRoutes from "@/routes";

/**
 * Provider stack for the SPA.
 *
 * BrowserRouter is outermost because AuthProvider's `onRedirectCallback` needs
 * `useNavigate` to return the user to the route they originally requested after
 * the Auth0 round trip.
 *
 * AnalyticsTracker sits outside RequireAuth so sign-in failures, which
 * RequireAuth renders in place of the app, are tracked too.
 */
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AnalyticsTracker />
        <SwrProvider>
          <ReduxProvider>
            <PersistGate loading={null} persistor={persistor}>
              <HostServiceProvider>
                <RequireAuth>
                  <AppRoutes />
                </RequireAuth>
              </HostServiceProvider>
            </PersistGate>
          </ReduxProvider>
        </SwrProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
